var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7988 0.87868C22.9703 -0.292893 24.8698 -0.292894 26.0414 0.87868L31.6271 6.46437C32.7987 7.63594 32.7987 9.53544 31.6271 10.707L11.1772 31.1569C10.6998 31.6343 10.0753 31.9367 9.40474 32.0152L3.35779 32.7232C1.48393 32.9426 -0.124905 31.3984 0.017493 29.5171L0.495117 23.2071C0.549265 22.4917 0.857963 21.8195 1.36524 21.3122L21.7988 0.87868ZM20.3076 8.02671L24.4791 12.1982L28.0915 8.58569L23.9201 4.41421L20.3076 8.02671ZM21.6506 15.0266L17.4791 10.8551L4.45573 23.8786L4.09765 28.6092L8.59448 28.0828L21.6506 15.0266ZM36 39.9884L0 39.9884V35.9884L36 35.9884V39.9884Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.31fbb06015b7fd10bf8438b9157f310f.svg";
export { ForwardRef as ReactComponent };